import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {

  public faqs = [{
    question: 'What is Vertical Farming?',
    answer: 'Vertical farming is the practice of growing crops in vertically stacked layers to maximise the amount of produce that can be grown in a single area. We have coupled this with controlled environment agriculture and a method of growing called hydroponics to bring you crops that are unmatched in taste and quality. <br> Visit our website for more information - www.honestgreens.asia'
  },
  {
    question: 'Don\’t plants need sunlight?',
    answer: 'Nope. Plants don’t need sun, they need particular frequencies of light. We provide the exact frequencies they need by using LED lights, this helps our plants grow more efficiently. We also use spectrum to adjust aspects like color, flavor, and texture.'
  },
  {
    question: 'Don’t plants need soil?',
    answer: 'They don’t actually. Plants need water and nutrients, which are traditionally stored and provided by soil. As commercial agriculture has strained to produce enough food for our growing population, the soil has become overloaded to the point of becoming toxic in some cases. Our nutrient solution is filtered, sterilized with UltraViolet light and recirculated. Our crops receive all the benefits of soil with none of the risk'
  },
  {
    question: 'Is your produce organic?',
    answer: 'Our produce is not considered organic as we are a hydroponic farm. This means that our crops are grown in nutrient rich water instead of soil. We do maintain extremely high health standards and our products are totally pesticide free!'
  }]

  constructor() { }

  ngOnInit() {
  }

}
